import styled from "@emotion/styled";

export const Styled = styled.div`
  /* =========================
     Scrollbar variables
     ========================= */
  --scrollbar-width: 15px;

  /* Size of the scrollbar buttons */
  --scrollbar-button-size: 10px;

  --scrollbar-track-color: #fff;

  --scrollbar-thumb-color: #8b8b8b;
  --scrollbar-thumb-hover-color: #636363;

  --scrollbar-thumb-border: 3px;

  --scrollbar-arrow-color: #b8b8b8;
  --scrollbar-arrow-hover-color: #666;
  --scrollbar-arrow-size: 10px 6px;

  overflow-y: auto;
  overflow-x: hidden;

  scrollbar-width: auto;
  scrollbar-gutter: stable;

  .vertical-scroll-bar-inside {
    width: 1px;
  }

  /* =========================
     Scrollbar
     ========================= */

  &.custom-scroll::-webkit-scrollbar {
    width: var(--scrollbar-width);
  }

  /* =========================
     Track
     ========================= */

  &.custom-scroll::-webkit-scrollbar-track {
    background: var(--scrollbar-track-color);
  }

  /* =========================
     Thumb
     ========================= */

  &.custom-scroll::-webkit-scrollbar-thumb {
    background: var(--scrollbar-thumb-color);
    border-radius: 999px;
    border: var(--scrollbar-thumb-border) solid transparent;
    background-clip: content-box;
  }

  &.custom-scroll::-webkit-scrollbar-thumb:hover {
    background: var(--scrollbar-thumb-hover-color);
    background-clip: content-box;
  }

  /* =========================
     Scrollbar buttons
     ========================= */

  &.custom-scroll::-webkit-scrollbar-button {
    display: block;
    width: var(--scrollbar-width);
    height: 0;
    padding: 0;
    margin: 0;
    background-color: var(--scrollbar-track-color);
    &.custom-scroll:hover {
      background-color: var(--scrollbar-thumb-color);
    }
  }

  /* =========================
     ↑ Arrow
     ========================= */

  &.custom-scroll::-webkit-scrollbar-button:single-button:vertical:decrement {
    width: var(--scrollbar-width);
    height: var(--scrollbar-button-size);

    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='20' height='12'%3E%3Cpolygon points='10,0 20,12 0,12' fill='%23666666'/%3E%3C/svg%3E");
    background-repeat: no-repeat;
    background-position: center;
    background-size: var(--scrollbar-arrow-size);
  }

  /* ↑ Hover */
  &.custom-scroll::-webkit-scrollbar-button:single-button:vertical:decrement:hover {
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='20' height='12'%3E%3Cpolygon points='10,0 20,12 0,12' fill='%23555555'/%3E%3C/svg%3E");
  }

  /* =========================
     ↓ Arrow
     ========================= */

  &.custom-scroll::-webkit-scrollbar-button:single-button:vertical:increment {
    width: var(--scrollbar-width);
    height: var(--scrollbar-button-size);

    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='20' height='12'%3E%3Cpolygon points='0,0 20,0 10,12' fill='%23666666'/%3E%3C/svg%3E");
    background-repeat: no-repeat;
    background-position: center;
    background-size: var(--scrollbar-arrow-size);
  }

  /* ↓ Hover */
  &.custom-scroll::-webkit-scrollbar-button:single-button:vertical:increment:hover {
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='20' height='12'%3E%3Cpolygon points='0,0 20,0 10,12' fill='%23555555'/%3E%3C/svg%3E");
  }
`;
